import { render } from "./ContactForm.vue?vue&type=template&id=264ac100&scoped=true"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"

import "./ContactForm.vue?vue&type=style&index=0&id=264ac100&scoped=true&lang=css"

import exportComponent from "/home/richard/Code/CHE/project/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264ac100"]])

export default __exports__